<template>
  <div class="advisor-new" v-loading.fullscreen.lock="loading">
    <el-row>
      <ai-breadcrumb />
    </el-row>
    <el-form class="form" ref="form" :model="form" size="small" label-width="180px">
      <el-form-item :label="$t('gpt.desc')">
        <el-input v-model="form.desc" size="small" style="width: 30%"></el-input>
      </el-form-item>
      <el-row>
        <el-form-item class="source-img-form-item" :label="$t('gpt.productImage')" required>
          <el-upload :action="aiApiRoot + '/v1/images'" accept=" .jpg, .jpeg, .png"
            :headers="{ Authorization: this.token }" list-type="picture-card" :file-list="sourceFileList"
            :on-change="handleChangeSource" :on-remove="handleRemoveSource" :data="{ group: 'gpt' }" :multiple="true">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="">
          <div class="notice">
            <i18n path="gpt.newInfoAdvisor" tag="div">
            </i18n>
          </div>
        </el-form-item>
      </el-row>
      <el-form-item>
        <el-button type="primary" icon="el-icon-s-promotion" @click="onSubmit">{{ $t("common.submit") }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { createTask } from "@/api/gpt";
import AiBreadcrumb from "@/components/AiBreadcrumb";
import { getToken } from "@/utils/auth";
import { aiApiRoot } from "@/utils/server";

export default {
  components: {
    AiBreadcrumb,
  },
  data() {
    return {
      token: "Bearer " + getToken(),
      aiApiRoot,
      total: 0,
      form: {
        desc: "",
        sourceIds: [],
      },
      sourceFileList: [],
      loading: false,
    };
  },
  methods: {
    initForm() {
      this.form = {
        desc: "",
        sourceIds: [],
      }
    },
    onSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.sourceFileList.length === 0) {
            this.$message({
              message: "Please upload model image",
              type: "warning",
            });
            return;
          }
          let params = {
            ...this.form, category: "advisor", sourceIds: []
          }
          let finish = true;
          this.sourceFileList.forEach((t) => {
            if (t.status !== "success") {
              finish = false;
              return;
            }
            if (
              t.response &&
              t.response.result &&
              t.response.result.length > 0
            ) {
              params.sourceIds.push(t.response.result[0].id);
            }
          });
          if (!finish) {
            this.$message({
              message: "Image upload not finish, can't submit",
              type: "warning",
            });
            return;
          }
          this.$confirm(
            this.$t("tagger.submitTask"),
            this.$t("common.pleaseConfirm"),
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          ).then(() => {
            this.loading = true;
            createTask(params).then((response) => {
              this.loading = false;
              if (response.success) {
                this.$notify({
                  title: this.$t("common.saveSucc"),
                  message: this.$t("common.indirecting"),
                  type: "success",
                });
                let suffix = response.result && response.result.id ? "/" + response.result.id : ""
                this.$router.push("/services/agent-advisor/advisor" + suffix).catch(() => { });
              }
            })
              .catch(() => {
                this.loading = false;
              });
          })
        }
      });
    },
    handleChangeSource(file, fileList) {
      this.sourceFileList = fileList;
    },
    handleRemoveSource(file, fileList) {
      this.sourceFileList = fileList;
    },
  },
  mounted() {
    this.initForm();
  },
};
</script>

<style lang="scss" scoped>
.advisor-new {
  .form {
    margin-top: 25px;
  }

  ::v-deep .el-upload--picture-card {
    width: 124px;
    height: 124px;
    line-height: 128px;
  }

  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 124px;
    height: 124px;
    line-height: 128px;
  }

  ::v-deep .el-upload-list__item-status-label i {
    position: absolute;
    right: 15px
  }

  .target-container {
    margin-top: 15px;

    ::v-deep .el-card__header {
      padding: 5px 15px;
    }

    ::v-deep .el-card__body {
      padding: 5px;
    }

    .target-block {
      text-align: center;

      .target-img {
        max-width: 80px;
      }
    }

    .pagination-container {
      margin: 0;
      padding-top: 0;
      padding-bottom: 5px;
    }
  }

  ::v-deep .mask-dialog .el-form {
    margin-top: 10px;
    margin-bottom: -10px;
  }

  ::v-deep .el-dialog__footer {
    border-top: 1px solid #ebeef5;
  }

  .notice {
    font-size: small;
    color: #606266;
    font-weight: bold;
    white-space: pre-line;
    line-height: 150%;

    .brand {
      color: orange;
    }
  }
}
</style>